export default __webpack_public_path__ + "static/media/machina_doctrina.bf385660.png";